module.exports = __webpack_public_path__ + "static/img/2.6dbe8d4a.jpg";